import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';

const DepositMoney = loadable(
  () => import('../Account/Finance/DepositMoney'),
  { fallback: <Loading /> }
);

const AsyncPendingDepositMoney = props => {
  const pageConfig = {
    headerType: 'simple',
    footerType: 'none',
    helmet: {
      bodyAttributes: {
        class: `${props.userAgent.device?.type} bg-pending-gray hide-betslip hide-sticky-navigation`
      },
      title: 'Bilyoner.com | Para Yatırma'
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <DepositMoney { ...props } headerColor="white" useFastDepositModal />
    </ApplicationLayout>
  );
};

AsyncPendingDepositMoney.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncPendingDepositMoney;
